module.exports = __webpack_public_path__ + "img/21_16.ef142091.png";